import { render, staticRenderFns } from "./Password_find.vue?vue&type=template&id=48bf00fb&scoped=true&"
import script from "./Password_find.vue?vue&type=script&lang=js&"
export * from "./Password_find.vue?vue&type=script&lang=js&"
import style0 from "./Password_find.vue?vue&type=style&index=0&id=48bf00fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf00fb",
  null
  
)

export default component.exports